"use client";

import { useEffect, useRef } from "react";
import { mapProductToGA4Item, pushDataLayer, type ProductForGA4 } from "@/lib/gtm";

interface Props {
  listId: string;
  listName: string;
  products: ProductForGA4[];
}

/**
 * Pousse view_item_list une seule fois au mount.
 * Ne rend rien.
 */
export function ProductListTracker({ listId, listName, products }: Props) {
  // En SPA, ce composant peut être re-mounté à chaque navigation client-side ;
  // on garde une garde dépendante de listId+productCount pour éviter les doubles push
  // sur un même rendu.
  const pushed = useRef<string | null>(null);

  useEffect(() => {
    const key = `${listId}::${products.length}`;
    if (pushed.current === key) return;
    pushed.current = key;

    pushDataLayer("view_item_list", {
      item_list_id: listId,
      item_list_name: listName,
      items: products.map((p, i) => mapProductToGA4Item(p, i)),
    });
  }, [listId, listName, products]);

  return null;
}
